// extracted by mini-css-extract-plugin
export default {"recos":"D5-z","productCardOverride":"E5-z","rowHasBadge":"F5-z"};